import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetchVisitImages from '../../../hooks/visit/images/useFetchVisitImages';
import { setSelectedVisitImageAction } from '../../../redux/actions/visitImagesActions';
import Container from '../../shared/container/Container';
import Images from '../../shared/images/Images';
import PageContainer from '../../shared/page/PageContainer';
import EmptyContent from '../../shared/table/EmptyContent';
import DeleteVisitImageModal from './modals/DeleteVisitImageModal';
import ImagesViewModal from './modals/ImagesViewModal';
import VisitImagesHeader from './VisitImagesHeader';

const VisitImageContainer = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const { loading, visitImages, refresh } = useFetchVisitImages(vin, id);
  const [showImageViewModal, setShowImageViewModal] = useState(false);
  const [showDeleteImageModal, setShowDeleteImageModal] = useState(false);

  const openDeleteModal = (visitImage) => {
    dispatch(setSelectedVisitImageAction(visitImage));
    setShowDeleteImageModal(true);
  };

  const handleDeleteSubmit = async () => {
    refresh();
    setShowDeleteImageModal(false);
  };

  const renderModals = () => (
    <>
      {showImageViewModal && <ImagesViewModal onModalClose={() => setShowImageViewModal(false)} />}
      {showDeleteImageModal && (
        <DeleteVisitImageModal onModalSubmit={handleDeleteSubmit} onModalClose={() => setShowDeleteImageModal(false)} />
      )}
    </>
  );

  const renderImages = () => (
    <>
      <hr />
      <div className="max-h-72">
        <Images
          images={visitImages}
          readOnly={readOnly}
          loading={loading}
          fullSize={false}
          onDelete={openDeleteModal}
          onClick={() => setShowImageViewModal(true)}
        />
      </div>
    </>
  );

  return (
    <PageContainer className="mt-2 md:mt-4">
      {renderModals()}
      <div className="grid grid-cols-1">
        <Container>
          <VisitImagesHeader readOnly={readOnly} />
          {visitImages.length === 0 && !loading && <EmptyContent title={'Фотографії відсутні'} />}
          {visitImages.length > 0 && renderImages()}
        </Container>
      </div>
    </PageContainer>
  );
};

export default VisitImageContainer;
